import { useMutation, useQueryClient } from "@tanstack/react-query";
import Community from "../interfaces/community";
import useApiCommunity from "./useApiCommunity";

type CreateCommunityParams = {
  token: string;
  community: Community;
};

const useCreateCommunity = () => {
  const queryClient = useQueryClient();
  const { createCommunity } = useApiCommunity();

  return useMutation({
    mutationFn: ({ token, community }: CreateCommunityParams) =>
      createCommunity(token, community),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["communities"] });
    },
  });
};

export default useCreateCommunity;
